// extracted by mini-css-extract-plugin
export default {"modalLink":"XeLPUuqZxZP3LG29BpDi","needRow":"LIxx0uQcUS0_ubyiPHc8","needData":"cdQMPj_ZmyPdKmzu8ROH"};